import * as api from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useUserLookup(search: string) {
  return useQuery(queryKeys.user.search(search), () => {
    return api.getUserLookup(search);
  });
}
